import type {} from "react";

interface ProgressBarProps {
  /** 0..1 */
  value: number;
  current: number;
  total: number;
}

export function ProgressBar({ value, current, total }: ProgressBarProps) {
  const pct = Math.round(Math.min(1, Math.max(0, value)) * 100);
  return (
    <div className="w-full">
      <div
        className="h-1.5 w-full overflow-hidden rounded-full bg-slate-200"
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Step ${current} of ${total}`}
      >
        <div
          className="h-full rounded-full bg-brand-600 transition-all duration-300 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="mt-2 text-xs font-medium text-ink-muted">
        Step {current} of {total}
      </div>
    </div>
  );
}
